<main class="auth-page">
  <div class="top-row">
    <button type="button" class="back-btn" [attr.aria-label]="'auth.common.backAria' | translate" (click)="goBack()">
      <sz-icon name="arrow-back" [size]="20" />
    </button>
    <sz-brand-block [compact]="true" />
  </div>

  <div class="auth-head">
    <div class="auth-head__kicker">
      <span>{{ 'auth.login.kicker' | translate }}</span>
    </div>
    <h1 class="auth-head__title">
      {{ 'auth.login.titleMain' | translate }}
      <span class="auth-head__accent">{{ 'auth.login.titleAccent' | translate }}</span>
    </h1>
    <p class="auth-head__lead">{{ 'auth.login.lead' | translate }}</p>
  </div>

  <auth-google-sign-in-button
    [label]="'auth.common.googleContinue' | translate"
    [loading]="loading()"
    (clicked)="onGoogleClick()" />

  @if (showAppleSignIn) {
    <auth-apple-sign-in-button
      [label]="'auth.common.appleContinue' | translate"
      [loading]="loading()"
      (clicked)="onAppleClick()" />
  }

  <auth-divider [label]="'auth.common.orEmail' | translate" />

  <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
    <div class="field">
      <div class="field__row">
        <span class="field__label">{{ 'auth.common.fieldEmail' | translate }}</span>
      </div>
      <sz-text-input
        type="email"
        autocomplete="email"
        [placeholder]="'auth.common.emailPlaceholder' | translate"
        prefixIcon="mail"
        formControlName="email"
        [errorText]="emailError()" />
    </div>

    <div class="field">
      <div class="field__row">
        <span class="field__label">{{ 'auth.common.fieldPassword' | translate }}</span>
        <button type="button" class="lnk" (click)="goForgot()">{{ 'auth.login.forgotLink' | translate }}</button>
      </div>
      <sz-password-input
        autocomplete="current-password"
        [placeholder]="'auth.common.passwordPlaceholder' | translate"
        formControlName="password"
        [errorText]="passwordError()" />
    </div>

    @if (errorMessage(); as msg) {
      <p class="auth-error" role="alert">{{ msg }}</p>
    }

    <button
      type="submit"
      class="cta cta--primary"
      [disabled]="loading() || form.invalid"
      [attr.aria-busy]="loading() ? 'true' : null">
      @if (loading()) {
        <span class="spinner" role="status" [attr.aria-label]="'auth.login.submitAria' | translate"></span>
      } @else {
        <span>{{ 'auth.login.submitCta' | translate }}</span>
        <sz-icon name="arrow-right" [size]="16" />
      }
    </button>
  </form>

  <p class="alt">
    {{ 'auth.login.altPrefix' | translate }}
    <a [routerLink]="registerPath">{{ 'auth.login.altLink' | translate }}</a>
  </p>
</main>
